import { useSyncExternalStore } from 'react';
import {
  addOneTrustConsentChangedListener,
  getActiveOneTrustGroups,
  parseConsents,
  removeOneTrustConsentChangedListener,
} from './onetrust';

function subscribe(listener: () => void) {
  addOneTrustConsentChangedListener(listener);

  return () => {
    removeOneTrustConsentChangedListener(listener);
  };
}

function getServerSnapshot() {
  return null;
}

/**
 * Returns null before OneTrust is loaded
 */
export const useCookieConsent = () => {
  const consentGroup = useSyncExternalStore(
    subscribe,
    getActiveOneTrustGroups,
    getServerSnapshot
  );

  if (!consentGroup) return null;

  return parseConsents(consentGroup);
};
